import React from 'react';
import styled from 'styled-components';

const Expanded = ({children,isExtraOpen,setIsExtraOpen}) => {

    const openExtra = () => {
        setIsExtraOpen(!isExtraOpen);   
    }

    return (
        <ExpandedContent className={isExtraOpen ? 'open' : 'close'}>
            <div className="injected">
                {children}
            </div>
            <ClosePullout onClick={openExtra}>close</ClosePullout>
        </ExpandedContent>
    )
}




const ExpandedContent = styled.div`
    display: flex;
    /* justify-content: center;
    align-items: center; */
    flex-direction: column;
    background: #333147;
    color: #fff;
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    right: 0; 
    bottom: 0;
    padding: 3em;
    transition: all .5s ease;
    overflow-x: hidden;
    z-index: 999999;

    &.close{
        transform: translateX(100%);
        transition: all .5s ease;
        overflow-x: hidden;
    }

    div{
        
        &:first-of-type{
            margin-left: 60px;
            max-width: 70%;

            @media (max-width: 1060px) {
                margin-left: 0;
                max-width: 100%;
            }   
        }

        @media (max-width: 1060px) {
         display: block;
         width: 100%;
        }
    }

    p{
        margin: 20px 0;
        font-size: 18px;
    }

    h1{
        font-family: 'MarkPro-Black';
        font-size: 3em;


        @media (max-width: 1060px) {
            margin-top: 60px;
        }
        
    }

    ul{
        li{
            margin: 10px 0 10px 17px;
            font-size: 18px;
        }
    }

    @media (max-width: 1060px) {
         display: block;
         padding: 1em;
         /* background:orange; */
         height: 100vh;
         /* overflow: hidden !important; */
         /* margin-bottom: 200px; */
    }


`;

const ClosePullout = styled.div`
  

    background: rgb(234,179,48);
    background: linear-gradient(0deg, rgba(234,179,48,1) 0%, rgba(213,102,95,1) 50%, rgba(202,0,136,1) 100%);
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 0;
    writing-mode: tb-rl;
    transform: translateY(-50%) rotate(-180deg);
    font-size: 22px;
    /* width: 40px;
    height: 140px; */
    padding: 20px;
    text-align: center;
    writing-mode: vertical-rl;
    text-orientation: mixed;
    cursor: pointer;
    font-family: 'MarkPro-Bold';
    line-height: 1;

    @media (max-width: 1060px) {
         display: block;
         transform: translateY(0) rotate(0);
         writing-mode: unset;
         position: absolute;
         top: 0;
         left: 0;
         right: 0;
        background: rgb(234,179,48);
        background: linear-gradient(90deg,rgba(234,179,48,1) 0%,rgba(213,102,95,1) 50%,rgba(202,0,136,1) 100%);
    }
`;


export default Expanded;